<template>
	<div class="height-100dvh">
		<div class="mhp-main-header d-flex align-items-center pl-3">
			<div>
				<img
					@click="$router.go(-1)"
					src="../../../assets/img/homepage/ms-header-arrow.svg"
					alt=""
					class="mr-2"
				/>
			</div>
			<div>Tasks</div>
		</div>
		<div class="cand-mob-maincontainer p-3">
			<div v-if="taskShimmer" class="mhp-main-container p-2">
				<div>
					<div
						class="cd-helpsec-cards p-1 m-3"
						v-for="index in 10"
						:key="index + 'demo-shim'"
					>
						<b-skeleton class="mt-2 w-100 h-15"></b-skeleton>
					</div>
				</div>
			</div>

			<div
				v-else-if="allTasks.length > 0 && !taskShimmer"
				class="mhp-main-container p-2"
			>
				<div class="hpt-overflow">
					<div
						v-for="(task, i) in allTasks"
						:key="i + 'task'"
						class="hm-helpsec-cards p-1 pl-2 m-3"
					>
						<div class="hmpage-blueline position-absolute"></div>

						<img
							v-if="task.type == 1"
							src="../../..//assets/img/homepage/hp-bluepage.svg"
							class="mr-2 pl-1"
							alt=""
						/>

						<img
							v-else-if="task.type == 2"
							src="../../../assets/img/homepage/hmpg-bluepeople.svg"
							class="mr-2 pl-1"
							alt=""
						/>

						<img
							v-else-if="task.type == 3"
							src="../../../assets/img/homepage/hmpg-bluetime.svg"
							class="mr-2 pl-1"
							alt=""
						/>

						<img
							v-else-if="task.type == 4"
							src="../../../assets/img/homepage/hmpg-yellowpage.svg"
							class="mr-2 pl-1"
							alt=""
						/>
						<div class="hp-card-headingtxt text-break" style="width: 77%">
							<div v-html="formatTaskData(task.data)"></div>
						</div>
						<img
							@click="
								task.type != 2
									? goToTaskLink(task.link)
									: redirectToTheLink(task.link)
							"
							src="../../../assets/img/homepage/hmpg-right-blueshare.svg"
							class="ml-2"
							alt=""
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getTaskData } from "../../../utils/apiFunctions.js";
export default {
	name: "mobComponentTask",
	components: {},
	data() {
		return {
			taskShimmer: true,
			allTasks: [],
		};
	},
	created() {
		this.getTasksUpdate();
	},
	methods: {
		formatTaskData(data) {
			const regex = /"(.*?)"/g;
			const matches = data.match(regex);

			if (matches) {
				matches.forEach((match) => {
					data = data.replace(match, `<span>${match}</span>`);
				});
			}

			return data;
		},
		goToTaskLink(tLink) {
			this.$router.push(tLink);
		},
		redirectToTheLink(linkCopy) {
			const textarea = document.createElement("textarea");
			textarea.value = linkCopy;
			document.body.appendChild(textarea);
			textarea.select();
			document.body.removeChild(textarea);
			window.open(linkCopy, "_blank");
		},

		async getTasksUpdate() {
			try {
				const resp = await getTaskData();
				if (resp.status == 200) {
					this.allTasks = resp.data.data;
				} else {
					console.log("API ERROR");
				}
			} catch (error) {
				console.log(error);
			}
			this.taskShimmer = false;
		},
	},
};
</script>
<style>
.mhp-main-header {
	padding-top: env(safe-area-inset-top);
	height: calc(60px + env(safe-area-inset-top));
	width: 100%;
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 18px;
	color: #000000;
}

.cand-mob-maincontainer {
	position: relative;
	background: var(--bg-lightblueback);
	height: calc(100dvh - (60px + env(safe-area-inset-top)));
	overflow-x: hidden;
	padding: 15px 15px 15px 75px;
}

.mhp-main-container {
	width: 100%;
	height: 100%;
	background: #ffffff;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
}

.mhp-helpsec-cards {
	height: 49.33px;
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.hpt-overflow {
	height: 100%;
	overflow: auto;
}

.hmpage-blueline {
	width: 3px;
	height: 91%;
	left: 3px;
	top: 2px;
	background: #20639b;
	border-radius: 1px;
}

.hp-card-headingtxt span {
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-weight: 600;
	color: #20639b;
}

.hp-card-headingtxt {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 12px;
	color: #3a3c40;
}

.hpt-i-overflow {
	height: 100%;
	overflow: auto;
}
</style>
